import { DefaultTheme } from '../theme';

export const CSS = {
	wrap: 'c-ColorPicker__wrap',
	dot: 'c-ColorPicker__dot',
	customDot: 'c-ColorPicker__customDot',
	customDotIdle: 'c-ColorPicker__customDot--idle',
	customInput: 'c-ColorPicker__customInput',
	customIconCheck: 'c-ColorPicker__customIcon--check',
	customIconEdit: 'c-ColorPicker__customIcon--edit',
};

export const Style = {
	[CSS.wrap]: { display: 'flex', 'flex-wrap': 'wrap', gap: DefaultTheme.space(2) },
	// Selected ring is an inline per-dot box-shadow, so no border here (border-box keeps the fill full-diameter).
	[CSS.dot]: {
		'box-sizing': 'border-box',
		width: '28px',
		height: '28px',
		'border-radius': '50%',
		border: 'none',
		cursor: 'pointer',
		padding: 0,
		display: 'flex',
		'align-items': 'center',
		'justify-content': 'center',
		color: '#fff',
	},
	// The "any color" dot. Selected = inline `background` (the chosen color) + ring + check; idle below.
	[CSS.customDot]: { position: 'relative', overflow: 'hidden' },
	// Idle: a dashed outline + "+" until an off-palette color is picked (fill/ring are cleared inline).
	[CSS.customDotIdle]: {
		border: `1.5px dashed ${DefaultTheme.font.color.supporting}`,
		color: DefaultTheme.font.color.supporting,
	},
	// Hover swaps the check for a pencil to signal "click to change".
	[CSS.customIconEdit]: { display: 'none', 'font-size': '16px' },
	[`${CSS.customDot}:hover .${CSS.customIconCheck}`]: { display: 'none' },
	[`${CSS.customDot}:hover .${CSS.customIconEdit}`]: { display: 'inline-block' },
	// The native picker fills the dot but stays invisible — clicking the dot opens the OS color dialog.
	[CSS.customInput]: {
		position: 'absolute',
		inset: 0,
		width: '100%',
		height: '100%',
		opacity: 0,
		cursor: 'pointer',
		border: 'none',
		padding: 0,
	},
};
